import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { dateToString } from "components/Shared/Formatters";
import { ReadOnlyField } from "components/Shared";

class TimeLogList extends React.Component {

  constructor(props) {
    super(props);

    this.getEfficiency = this.getEfficiency.bind(this);
    this.getEfficiencyClassName = this.getEfficiencyClassName.bind(this);
  }

  getEfficiency() {
    return this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal > 0 ? Number.parseFloat((this.props.appraisalSurveyInfo?.appraiserLogMinutesExpected / this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal) * 100).toFixed(0) : 0;
  }

  getEfficiencyClassName() {
    return this.getEfficiency() < 100 ? "alert-value" : "good-value";
  }

  render() {
    return (
      <div width="100%">
        <div className="time-log-summary">
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField title="Expected Minutes" fieldValue={this.props.appraisalSurveyInfo?.appraiserLogMinutesExpected} />
          </div>
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField title="Actual Minutes" fieldValue={this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal} />
          </div>
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField className={this.getEfficiencyClassName()} title="Efficiency" fieldValue={this.getEfficiency() + "%"} />
          </div>
        </div>
        <div>
          <TableContainer component="div" style={{ maxHeight: 600, width: "100%" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: 80 }}>Work Date</TableCell>
                  <TableCell style={{ width: 180 }}>User</TableCell>
                  <TableCell>Minutes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.timeLogs
                  .sort((a, b) => a.workDate < b.workDate)
                  .map(({ id, workDate, userName, timeMinutes }) => (
                    <TableRow key={id}>
                      <TableCell style={{ verticalAlign: "top", paddingTop: "5px" }}>{dateToString(workDate)}</TableCell>
                      <TableCell style={{ verticalAlign: "top", paddingTop: "5px" }}>{userName}</TableCell>
                      <TableCell style={{ verticalAlign: "top", paddingTop: "5px" }}>{timeMinutes}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  }
}

TimeLogList.propTypes = {
  timeLogs: PropTypes.array,
  appraisalSurveyInfo: PropTypes.object.isRequired
};

export default TimeLogList;